import { NotificationReducer } from '@elotech/components';
import auth from 'common/auth/Reducer.js';
import info from 'common/info/Reducer.js';
import ui from 'common/ui/Reducer.js';
import keycloak from 'keycloak/Reducer.js';
import { combineReducers } from 'redux';
import { ProcessosAgrupadosReducer } from 'state/reducers';

import config from '../config/Reducer.js';
import entidade from '../entidades/Reducer.js';

export default combineReducers({
  auth,
  config,
  entidade,
  info,
  keycloak,
  notification: NotificationReducer,
  processosAgrupados: ProcessosAgrupadosReducer,
  ui
});
